const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEzIDM0MiI+CjxyZWN0IHk9IjAiIGZpbGw9IiNmZGRhMjUiIHdpZHRoPSI1MTMiIGhlaWdodD0iMzQyIi8+CjxyZWN0IHk9IjAiIHdpZHRoPSIxNzEiIGhlaWdodD0iMzQyIi8+CjxyZWN0IHg9IjM0MiIgeT0iMCIgZmlsbD0iI2VmMzM0MCIgd2lkdGg9IjE3MSIgaGVpZ2h0PSIzNDIiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=BE-b670ddb8.mjs.map
